export const buildHealthCardParams = (filters = {}) => {
  const params = {};
  if (filters?.year) params.year = filters.year;
  if (filters?.quarter) params.quarter = filters.quarter;
  if (filters?.salesRep) params.salesperson = filters.salesRep;
  if (filters?.productDirector) params.product_director = filters.productDirector;
  if (filters?.solutionCategory) params.solution_category = filters.solutionCategory;
  if (filters?.stage) params.stage = filters.stage;
  return params;
};
